var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.611,
    height: 33.611,
    viewBox: "0 0 33.611 33.611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.53,0H3.081A3.108,3.108,0,0,0,0,3.081V30.53a3.108,3.108,0,0,0,3.081,3.081H30.53a3.108,3.108,0,0,0,3.081-3.081V3.081A3.108,3.108,0,0,0,30.53,0ZM9.8,28.009H4.2V12.6H9.8ZM7,10.783A2.586,2.586,0,0,1,4.2,8.263,2.613,2.613,0,0,1,7,5.6,2.586,2.586,0,0,1,9.8,8.123,2.613,2.613,0,0,1,7,10.783ZM29.409,28.009h-5.6v-8.4c0-2.241-1.54-2.8-1.961-2.8s-2.241.28-2.241,2.8v8.4H14V12.6h5.6v2.241c.84-1.26,2.241-2.241,4.9-2.241s4.9,2.1,4.9,7Z",
    fill: "#222f3e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e2c474d05ae410e58194b2cbf8da52f9.svg";
export { ForwardRef as ReactComponent };